module.exports = __webpack_public_path__ + "static/img/interview-2-2.88db417.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/interview-2-2.png
// module id = 4CMS
// module chunks = 1